export default {
  name: 'function'
};